import { Component } from '@angular/core';
import { OnlineStatusService, OnlineStatusType } from "ngx-online-status";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'fire-insurance';

  status: OnlineStatusType = this.onlineStatusService.getStatus(); // get initial status

  constructor(private onlineStatusService: OnlineStatusService) {
    this.onlineStatusService.status.subscribe((status: OnlineStatusType) => {
      console.log("🚀 ~ file: app.component.ts:20 ~ AppComponent ~ this.onlineStatusService.status.subscribe ~ status", status)
      // use status
      this.status = status;
    });
  }
}
